export const ManagerTypes = {
    ENERGY_MANAGER: 'energymanager',
    DATA_MANAGER: 'datamanager',
};
